export const createGoogleMapsIframe = (url: string): string => {
  const coordMatch = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
  const lat = coordMatch ? coordMatch[1] : null;
  const lng = coordMatch ? coordMatch[2] : null;

  const query = lat && lng ? `${lat},${lng}` : '';

  return `<iframe
    width="100%"
    height="450"
    frameborder="0"
    style="border:0;border-radius:8px;"
    referrerpolicy="no-referrer-when-downgrade"
    src="https://www.google.com/maps/embed/v1/place?key=${process.env.GOOGLE_API_KEY}&q=${query}"
    allowfullscreen>
  </iframe>`;
};
